import cls from "classnames";
import styles from "./Preload.module.scss";
import config from "../config";


type Props = {
  visible?: boolean;
}

/**
 * Shown before necessary data has been fethced.
 */
export default function Preload({ visible }: Props) {
  return (
    <div className={cls({
      [styles.container]: true,
      [styles.visible]: visible,
    })}>
      <img className={cls({[styles.preloaderImage]:true})} src={config.logoUrl} alt={config.companyName + " logotyp"}/>
    </div>
  )
}